(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pw-presale-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{if(event.target.matches('.product-buy-box')&&event.target.querySelector('[data-presale-blocked]'))event.preventDefault();},true);
  } catch(e) { console.error(e); }
})();

})();
